module.exports = __webpack_public_path__ + "img/LDSJ_STILL22.5a866ff2.jpg";